import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  viewChild,
} from '@angular/core';

import { MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';

export const CARD_SELECTION_TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
} as const;

export type CardSelectionType =
  (typeof CARD_SELECTION_TYPES)[keyof typeof CARD_SELECTION_TYPES];

@Component({
  selector: 'app-graphic-option-card',
  templateUrl: './graphic-option-card.component.html',
  styleUrls: ['./graphic-option-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatRadioModule, MatCheckboxModule, MatIconModule],
})
export class GraphicOptionCardComponent {
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly icon = input.required<string>();
  readonly value = input('');
  readonly selected = input(false);
  readonly mode = input<CardSelectionType>(CARD_SELECTION_TYPES.RADIO);

  readonly selectionChange = output();

  readonly radioButton = viewChild(MatRadioButton);

  onCardClick(): void {
    const rb = this.radioButton();
    if (this.mode() === CARD_SELECTION_TYPES.RADIO && rb) {
      rb._inputElement.nativeElement.click();
    } else if (this.mode() === CARD_SELECTION_TYPES.CHECKBOX) {
      this.selectionChange.emit();
    }
  }
}
